<template>
    <div class="free-orders">
        <el-row>
            <el-col :span="24">
                <el-alert
                        title="温馨提示"
                        type="success"
                        close-text="知道了"
                        show-icon>
                    <p>请首先授权拼多多高佣。  <a style="color: #ff0036" href="http://admin.tk.xcx.yftaoke.com/pdd_highcommission_settings.html" target="_blank">点击去授权</a></p>
                </el-alert>
                <div class="grid-content bg-purple-dark">
                    <el-form ref="form" :model="item" label-width="80px">
                        <el-form-item label="pid">
                            <el-col :span="12">
                                <el-input v-model="item.pid" placeholder="请输入pid，不填的话走，设置的默认pid"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="medium" @click="onSubmit">生成红包</el-button>
                            <el-button size="medium">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form ref="form" :model="result" label-width="80px">
                    <el-form-item label="AppId">
                        <el-col :span="12">
                            <el-input placeholder="" class="input-with-select" v-model="result.appId">
                                <el-button type="primary" slot="append"
                                           v-clipboard:copy="result.appId"
                                           v-clipboard:success="onCopy"
                                           v-clipboard:error="onError">一键复制
                                </el-button>
                            </el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="页面路径">
                        <el-col :span="12">
                            <el-input placeholder="" class="input-with-select" v-model="result.pagePath">
                                <el-button type="primary" slot="append"
                                           v-clipboard:copy="result.pagePath"
                                           v-clipboard:success="onCopy"
                                           v-clipboard:error="onError">一键复制
                                </el-button>
                            </el-input>
                        </el-col>
                    </el-form-item>
                </el-form>

            </el-col>
        </el-row>


    </div>

</template>
<script>
    import {pddApi} from "../../common/pddApi";

    export default {
        name: 'free-order',
        data() {
            return {
                item: {},
                result: {},
            }

        },
        methods: {
            onSubmit() {
                var that = this;
                pddApi.createPddRedPacketPromotion.call(that, that.item, function (res) {
                    if (res.result.item) {
                        that.successMsg("生成成功");
                        that.result = res.result.item;
                    }
                })
            },
            onCopy() {
                this.successMsg("复制成功");
            },
            onError() {
                this.failMsg("复制失败")
            },
        }
    }

</script>
<style lang="scss">

</style>